/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:33:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-04-30 14:40:43
 */

export default {
  path: 'trade_withdraw',
  component: () => import(/* webpackChunkName: "sys_log-list" */ '@/pages/trade/WithdrawList'),
  meta: {title:'交易流水'}
}
